import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './modules/layout/layout.component';
import { HomeModule } from './modules/home/home.module';
import { Error404Component } from './modules/layout/components/error404/error404.component';
import { AuthGuard } from './core/guards/auth-guard/auth.guard';
import { NavigatorsCheckGuard } from './core/guards/navigators-check-guard/navigators-check.guard';
import { NavigatorIncompatibleComponent } from './modules/layout/components/navigator-incompatible/navigator-incompatible.component';

// const routes: Routes = [
//   {
//     path: '',
//     component: LayoutComponent,
//     children: [
//       {
//         path: '', pathMatch: 'full', redirectTo: 'home'
//       },
//       {
//         path: 'home',
//         canLoad: [ NavigatorsCheckGuard ],
//         loadChildren: () => import('src/app/modules/home/home.module').then(m => m.HomeModule),
//       }
//     ],
//     runGuardsAndResolvers: 'always',
//   },
//   {
//     path: 'login',
//     canLoad: [ NavigatorsCheckGuard ],
//     loadChildren: () => import('src/app/modules/login/login.module').then(m => m.LoginModule)
//   },
//   { path: 'browser-no-compatible', component: NavigatorIncompatibleComponent },
//   { path: '**', component: Error404Component }
// ];

const ROUTES: Routes = [
  {
    path: '',
    component: LayoutComponent
  },
  {
    path: '**',
    component: LayoutComponent
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(ROUTES) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {
}
